module.exports = "<app-tabs-links></app-tabs-links>\n\n<router-outlet></router-outlet>\n"